<template>
  <div class="school_list_page">
    <div class="m">
      <div class="school_list_page_t">
        <div class="from_box">
          <div class="form_list">
            <el-input v-model="searchObj.name" style="width:180px;" @keyup.native.enter="search">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </div>
        <div>
          <type_filter :filterObj="filterObj3" @selctedType="selctedType"></type_filter>
        </div>
      </div>
      <template v-if="layerpageinfo.total > 0">
        <div class="school_list_page_b">
          <school_list :list="list"/>
        </div>
        <!-- 分页 -->
        <div class="page_box">
          <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
        </div>
      </template>
      <!-- 为空 -->
      <div class="no_list" v-else></div>
    </div>
  </div>
</template>

<script>
import type_filter from "@/components/type_filter/type_filter.vue";
import school_list from "@/components/list_item/school_list/school_list.vue";
import myPage from "@/components/myPage/myPage";
import api from "@/api/api";
export default {
  components: { type_filter, school_list, myPage },
  data() {
    return {
      input3: "",
      filterObj3: {
        name: "所在地区",
        code: "province",
        list: [],
        child: {
          //子字典
          name: "",
          selectIndex: -1,
          code: "city",
          list: [],
          filedType: "code"
        }
      },
      layerpageinfo: {
        pageSize: 10,
        pageNo: 0,
        total: 0
      },
      searchObj:{
        province: '',
        city: '',
        name: ''
      },
      list:[]
    };
  },
  created() {
    this.getDictionaries("China").then(res => {
      this.filterObj3.list = res;
    });
    this.getSchools();
  },
  methods: {
    /**获取对应类型字典
     * @params type 字典类型
     * */
    getDictionaries(type) {
      let obj = {
        typeCode: type,
        pageNo: 0,
        pageSize: 999
      };
      return new Promise(resolve => {
        this.api.getDictionaries(obj).then(res => {
          if (res.error["err_code"] !== 0) return;
          let list = res.obj.list || [];
          resolve(list);
        });
      });
    },
    //点击搜索
    search(){
      this.layerpageinfo.pageNo = 0;
      this.getSchools();
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getSchools();
    },
    // 获取学校列表
    getSchools() {
      this.api
          .getFrontSchools({
            ...this.layerpageinfo,
            ...this.searchObj
          })
          .then(res => {
            console.log(res);
            if (res.error.err_code !== 0) return;
            let list = res.obj.list;
            this.list = list.length ? list : [];
            this.layerpageinfo.total = res.obj.totalSize;
          });
    },
    //筛选点击
    selctedType(obj) {
      //选中的是父类 且 obj.list.code不为空
      if (obj.child && obj.list.code) {
        //code 等于 所属地区
        if (obj.code === "province") {
          //设置子字典选中全部
          this.filterObj3.child.selectIndex = -1;
          //设置子节点的选中为空
          this.searchObj[this.filterObj3.child.code] = "";
          //获取子字典
          this.getDictionaries(obj.list.code).then(res => {
            this.filterObj3.child.list = res;
          });
          //设置选中的值
          this.searchObj[obj.code] =
            (obj.filedType === "code" ? obj.list.code : obj.list.id) || "";
        }
      } else {
        //设置选中的值
        this.searchObj[obj.code] =
          (obj.filedType === "code" ? obj.list.code : obj.list.id) || "";
      }
      //获取列表数据
      this.search();
    }
  }
};
</script>

<style lang="scss">
.school_list_page {
  padding: 20px 0;
  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
  .school_list_page_t {
    background: #fff;
    .from_box {
      padding:  0 20px;
      .form_list {
        padding: 30px 0 20px;
        border-bottom: 1px dashed #eee;
        .el-input__inner{
          border-radius: 20px;
        }
      }
    }
  }
  .school_list_page_b {
    margin-top: 10px;
  }
}
</style>
